<template>
    <div class="sidebar">
        <button class="compose-button w-100 mb-3" @click="$router.push('/compose')">
            <PencilSquareIcon style="width: 21px;margin-right: 6px;margin-top: -4px;" />
            Compose
        </button>

        <ul class="nav flex-column">
            <li class="nav-item bg" v-for="link in links" :key="link.name">
                <router-link :to="link.path" class="nav-link d-flex align-items-center" active-class="active-link">
                    <component :is="link.icon" class="icon mx-2" />
                    <span class="ms-2">{{ link.name }}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>


<script>
import { PencilSquareIcon } from "@heroicons/vue/24/outline";


import {
    InboxIcon,
    StarIcon,
    PaperAirplaneIcon,
    DocumentTextIcon,
    TrashIcon,
    ArchiveBoxIcon,
    Cog6ToothIcon,
} from "@heroicons/vue/24/outline";


export default {
    data() {
        return {
            links: [
                { name: "Inbox", path: "/profile", icon: InboxIcon },
                { name: "Starred", path: "/starred", icon: StarIcon },
                { name: "Sent", path: "/sent", icon: PaperAirplaneIcon },
                { name: "Draft", path: "/draft", icon: DocumentTextIcon },
                { name: "Trash", path: "/trash", icon: TrashIcon },
                { name: "Archive", path: "/archive", icon: ArchiveBoxIcon },
                { name: "Configuration", path: "/config-index", icon: Cog6ToothIcon }
            ],
            PencilSquareIcon
        };
    },

    components: {
        PencilSquareIcon
    }

};
</script>

<style scoped>
.sidebar {
    width: 350px;
    background-color: #edf5fe;
    padding: 20px;
    min-height: 750px;
}

.nav-link {
    color: #2c3e50;
    display: flex;
    align-items: center;
    font-size: 16px;
    margin: 5px 0px;
    text-decoration: none;
}

.nav-link:hover,
.active-link {
    background-color: #0ed575;
    border-radius: 5px;
    color: #fff;
}

.nav-link i {
    margin-right: 10px;
}

.icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.compose-button {
    background-color: rgb(12, 175, 96);
    border: none;
    padding: 17px 1px;
    border-radius: 12px;
    color: white;
    width: 192px !important;
    font-size: 18px;
}
</style>
